import * as actionTypes from './actionTypes'

export const StatesForRegionRequested = () => ({
  type: actionTypes.STATES_FOR_REGION_REQUESTED,
})
